import { AdvancedSearchTypes } from 'app/types-shared';
import { ConditionTypesValueData } from 'app/components/filters/types';

export const getDefaultConditionTypesValueData = (advancedField: AdvancedSearchTypes): ConditionTypesValueData => {
  return {
    operator: advancedField.valueOperator,
    dbFunction: advancedField.dbFunctionValue
  };
};
